import { Component, OnInit } from '@angular/core';
import { RedirectService } from '../redirect/redirect.service';
import { TeamSelectionService } from './team-selection.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
@Component({
    selector: 'app-team-selection',
    templateUrl: './team-selection.component.html',
    styleUrls: ['./team-selection.component.scss']
})
export class TeamSelectionComponent implements OnInit {

    teamsList: any;
    filteredTeamsList: any;
    selectedTeam: any;
    searchTerm: string = '';
    showSearch: boolean = false;

    constructor(
        private _redirectService: RedirectService,
        private _teamSelectionService: TeamSelectionService,
        private _cookieService: CookieService,
        private _router: Router,
        private _paymentService: PaymentService
    ) { }

    ngOnInit() {
        this.teamsList = JSON.parse(localStorage.getItem('teams'));
        if (this.teamsList && this.teamsList.length > 0) {
            // Sort teams alphabetically by name
            this.teamsList.sort((a, b) =>
                a.teamDetails.name.toLowerCase().localeCompare(b.teamDetails.name.toLowerCase())
            );
            this.filteredTeamsList = [...this.teamsList];
            // Show search if more than 10 teams
            this.showSearch = this.teamsList.length > 10;
        }
    }

    filterTeams() {
        if (!this.searchTerm || this.searchTerm.trim() === '') {
            this.filteredTeamsList = [...this.teamsList];
        } else {
            const term = this.searchTerm.toLowerCase().trim();
            this.filteredTeamsList = this.teamsList.filter(team =>
                team.teamDetails.name.toLowerCase().includes(term)
            );
        }
    }

    teamSelected(team) {

        const email = localStorage.getItem('userEmail');

        // Removing timezone from local
        localStorage.removeItem('timezone');
        localStorage.removeItem('submittedFormIds');
        this._teamSelectionService.updateTokensByTeam({ email: email, teamId: team.teamDetails._id })
            .subscribe(
                (result: any) => {
                    // Deleting teams from local
                    localStorage.setItem('userRole', team.userRole);
                    localStorage.setItem('teamName', team.teamDetails.name);
                    localStorage.setItem('teamId', team.teamDetails._id);
                    // tslint:disable-next-line:max-line-length
                    if(result['data']['hazardTemplateId']) {
                        localStorage.setItem('hazardTemplateId', result['data']['hazardTemplateId'])
                    } else {
                        localStorage.getItem('hazardTemplateId') ? localStorage.removeItem("hazardTemplateId") : "";
                    }

                    // If timezone is there for user team saving in localstorage
                    if(result.data && result.data.timezone) {
                        localStorage.setItem('timezone', result.data.timezone);
                    }

                    if (this._paymentService.getParamValue('redirectUrl') === 'initiatePayment') {

                        this._paymentService.navigateToPayment();
                    } else {
                        if (this._cookieService.get('userpreferences-tutorial') && this._cookieService.get('userpreferences-tutorial') === '1') {
                            this._cookieService.delete('userpreferences-tutorial');
                            this._router.navigateByUrl('/starttour');
                        } else {
                            const role = localStorage.getItem("userRole");
                            if(role && (role == "webAdmin" || role == "supervisor")) {
                                if(result.data && result.data.defaultView) {
                                    const defaultView = result.data.defaultView;
    
                                    switch(defaultView) {
                                        case "dashboard":
                                            this._router.navigateByUrl('/dashboard');
                                            return;
                                        case "inspections":
                                            this._router.navigateByUrl('/submittedForms');
                                            return;
                                        case "hazards":
                                            const hazardTemplateId = localStorage.getItem("hazardTemplateId");
                                            if(hazardTemplateId && hazardTemplateId.length > 0) {
                                                this._router.navigateByUrl(`hazards/${hazardTemplateId}?isHazardForm=true`)
                                            }
                                        case "incidents":
                                            this._router.navigateByUrl('/incidentForms');
                                            return;
                                    }
                                }
                            }

                            this._redirectService.redirectBasedOnRoles();
                        }
                    }
                },
                err => {
                    console.error(err.error.message);
                });
    }

}



// WEBPACK FOOTER //
// ./src/app/team-selection/team-selection.component.ts